module.exports = __webpack_public_path__ + "img/10-EXOS.d7fdffb9.jpg";